/* eslint-disable import/no-anonymous-default-export */
export default (individualInvestment = [], action) => {
  switch (action.type) {
    case "GET_ALL_INDIVIDUAL_INVESTMENTS":
      return action.payload;
    case "CREATE_INDIVIDUAL_INVESTMENT":
      return [...individualInvestment, action.payload];
    case "APPROVE_INDIVIDUAL_INVESTMENT":
      return individualInvestment.filter((data) => data._id !== action.payload);
    case "DELETE_INDIVIDUAL_INVESTMENT":
      return individualInvestment.filter((data) => data._id !== action.payload);
    default:
      return individualInvestment;
  }
};
